import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { JWTProvider } from 'contexts/JWTContext';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';
import { store } from './app/store';
import './index.css';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// Register service worker for PWA support (conditional in dev)
import { DrawerProvider } from 'components/app/DrawerContext';

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '924266449726-d75bsjqosrijummr45d1f1dak0r435u1.apps.googleusercontent.com';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Provider store={store}>
    <React.StrictMode>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DrawerProvider>
          <BrowserRouter>
            <GoogleOAuthProvider clientId={googleClientId}>
              <JWTProvider>
                <App />
              </JWTProvider>
            </GoogleOAuthProvider>
          </BrowserRouter>
        </DrawerProvider>
      </LocalizationProvider>
    </React.StrictMode>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// Avoid stale UI during development by disabling SW caching
if (process.env.NODE_ENV === 'development') {
  serviceWorkerRegistration.unregister();
} else {
  serviceWorkerRegistration.register();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
